import { createContext } from 'react'

interface CheckboxItem {
  key: string
  value: number
  label: string
  search: string[]
  show?: boolean
  created?: boolean
}

interface VariableFormat {
  key: string
  value: number
  label: string
  show?: boolean
  show_sitio: boolean
  global_variable: boolean
  search: string[]
  created?: boolean
  id: number
  isOperator: boolean
  isData: boolean
  operator: string
}

interface CheckboxContext {
  checkedBox: CheckboxItem[]
  setCheckedBox: (checkedBox: CheckboxItem[]) => void
  variablesFormat: VariableFormat[]
  setVariablesFormat: (checkedBox: VariableFormat[]) => void
}

export const CheckboxContext = createContext<CheckboxContext | null>(null)
